// extracted by mini-css-extract-plugin
module.exports = {"downloadLink":"table-row_downloadLink__QnPYH"};